import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Location from "./components/Location";
import Faq from "./components/Faq";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingCta from "./components/FloatingCta";

export default function App(){
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Location />
        <Faq />
        <Gallery />
        <Contact />
      </main>
      <Footer />
      <FloatingCta /> {/* <- aquí */}
    </>
  );
}